import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { observer } from 'mobx-react';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { CashbackPopups, CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';
import { SessionStore, SignupSteps } from '@gamiphy/loyalty-station-desktop/store/session';
import { AppCashbackStore } from '@gamiphy/loyalty-station-desktop/store/appCashback';
import WheelPopup from './screens/wheel/WheelPopup';
import WelcomeGift from './screens/welcomeGift/WelcomeGift';
import Cashback from './screens/cashback/Cashback';
import SingupScreen from './screens/signup/SingupScreen';
import BogoCampaignPopup from './screens/bogo/BogoCampaignPopup';

const CashbackPopup: React.FC = () => {
  const [signup, setSignUp] = React.useState(false);

  const afterSignup = React.useCallback(() => {
    switch (CashbackPopupsStore.currentActivePopup) {
      case CashbackPopups.WelcomeGift:
      case CashbackPopups.Cashback:
        SessionStore.updateSession({ signupStep: SignupSteps.Success });
        break;
      case CashbackPopups.SpinTheWheel:
        setSignUp(false);
        break;
      default:
    }
  }, [CashbackPopupsStore.currentActivePopup]);

  const content = React.useMemo(() => {
    switch (true) {
      case CashbackPopupsStore.currentActivePopup === CashbackPopups.WelcomeGift && !!AppWelcomeGiftStore.welcomeGift:
        return <WelcomeGift welcomeGift={AppWelcomeGiftStore.welcomeGift} onSignupClick={() => setSignUp(true)} />;
      case CashbackPopupsStore.currentActivePopup === CashbackPopups.SpinTheWheel && !!CampaignUserStore.spinTheWheelCampaignUser:
        return <WheelPopup campaignUser={CampaignUserStore.spinTheWheelCampaignUser} openSignup={() => setSignUp(true)} />;
      case CashbackPopupsStore.currentActivePopup === CashbackPopups.Bogo && !!CampaignUserStore.bogoCampaignUser:
        return <BogoCampaignPopup campaignUser={CampaignUserStore.bogoCampaignUser} />;
      case CashbackPopupsStore.currentActivePopup === CashbackPopups.Cashback && AppCashbackStore.currentAppCashback?.enabled:
        return <Cashback onSignupClick={() => setSignUp(true)} />;
      default:
        return undefined;
    }
  }, [CashbackPopupsStore.currentActivePopup,
    CampaignUserStore.spinTheWheelCampaignUser,
    CampaignUserStore.bogoCampaignUser,
    AppCashbackStore.currentAppCashback,
    AppWelcomeGiftStore.welcomeGift]);

  const onClose = React.useCallback(() => {
    CashbackPopupsStore.closeCashbackPopup();
  }, []);

  return (
    <Dialog
      open
      onClose={onClose}
      disablePortal
      keepMounted
      maxWidth={false}
      PaperProps={{
        sx:
          {
            borderRadius: '12px',
          },
      }}
    >
      <DialogContent sx={{
        p: 0,
        color: '#000',
      }}
      >
        {signup ? <SingupScreen afterSignup={afterSignup} /> : content}
      </DialogContent>
    </Dialog>
  );
};

export default observer(CashbackPopup);
